import { createSelector } from '@reduxjs/toolkit';

import { ReferenceBarPropertyMetadataByID } from '../../../controller/types.ts';
import { formatReferenceViewID } from '../../../modules/referenceView/index.ts';
import { selectCompSequence } from './orderSelectors.ts';
import { selectPropertyIdentificationEntities } from './propertyDataSelectors/propertyIdentificationSelectors.ts';
import { selectTransactionEntities } from './propertyDataSelectors/transactionSelectors.ts';
import { transactionToToolkitListingID } from './utils/transactionToToolkitListingID.ts';

export const selectMetadataById = createSelector(
  [selectCompSequence, selectTransactionEntities, selectPropertyIdentificationEntities],
  (compSequence, transaction, propertyIdentification): ReferenceBarPropertyMetadataByID => {
    if (!compSequence || !transaction || !propertyIdentification) {
      return {};
    }

    const comps = Object.fromEntries(
      compSequence.map((compID) => [
        formatReferenceViewID({ type: 'comparable', compID }),
        {
          listingID: transactionToToolkitListingID(transaction[compID]),
          address: propertyIdentification[compID]?.address,
        },
      ]),
    );

    return {
      [formatReferenceViewID({ type: 'subject' })]: {
        listingID: transactionToToolkitListingID(transaction.subject),
        address: propertyIdentification.subject?.address,
      },
      ...comps,
    };
  },
);
